export const CHART_CONFIG = {
  BAR_THICKNESS: 32,
  MAX_BAR_THICKNESS: 32,
  BORDER_WIDTH: 1,
  BORDER_COLOR: '#E1E4EA',
  PATTERN_SIZE: 8,
  PATTERN_STROKE_COLOR: 'rgba(255, 255, 255, 0.3)',
  PATTERN_LINE_WIDTH: 1,
};

export const DEFAULT_FILTERS = [
  'Overview',
  'Used',
  'Expired',
  'Canceled',
  'Scheduled',
];

export const FILTERS_STATUS_VALUES_MAP = new Map([
  ['Overview', 'Overview'],
  ['Used', 'USED'],
  ['Expired', 'EXPIRED'],
  ['Canceled', 'CANCELED'],
  ['Rescheduled', 'EDITED'],
  ['Scheduled', 'RESERVED'],
]);

export const FILTERS_ORIGIN_SOURCE_VALUES_MAP = new Map([
  ['Autobook', 'AUTOBOOK'],
  ['Manual', 'MANUAL'],
  ['External', 'EXTERNAL'],
]);

export const SPLIT_VIEW_OPTIONS = [
  { label: 'Status', value: 'status' },
  { label: 'Origin Source', value: 'originSource' },
  { label: 'Terminal(Top 5)', value: 'terminal' },
];

export const EMPTY_FILTERS = {
  statuses: [],
  terminals: [],
  types: [],
  shippingLines: [],
  originSource: [],
  autobookStatus: [],
};
